
<a-config-provider :locale="chinese">
  <div id="febs">
    <router-view />
  </div>
</a-config-provider>
